<form [formGroup]="form" class="row">
  <!-- <div class="col-6">
    <div class="textCenter">
        <p class="texto">Nombre y Apellido Candidato:</p>
        <p>{{nombre}}</p>
    </div>
</div>
<div class="col-6">
    <div class="textCenter">
        <p class="texto">C.I:</p>
        <p>{{ci}}</p>
    </div>
</div>

<div class="col-12 textCenter">
    <p class="texto">Cargo a Aspirar:</p>
    <p>{{cargo}}</p>
</div> -->
  <!-- <div class="col-12 separador"></div> -->

  <!-- 
    <div class="col-6 displayFlex"> 
        <p class="inputRadio">Tiene Cuenta en el Banco</p>
       <mat-radio-group class="checleft" formControlName="tiene_cuenta" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="col-6 displayFlex">
        <p class="inputRadio">Son válidos los antecedentes laborales</p>
       <mat-radio-group class="checleft" formControlName="validos" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
   <div class="col-6 displayFlex">
        <p class="inputRadio width">Localidad de residencia es la misma o cercana a lugar de trabajo</p>
       <mat-radio-group class="checleft" formControlName="localidad" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="col-6 displayFlex">
        <p class="inputRadio">Son válidas las referencias laborales</p>
       <mat-radio-group class="checleft" formControlName="validas_referencias" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
  <div class="col-6 displayFlex"> 
        <p class="inputRadio">Laboró en el Banco anteriormente</p>
       <mat-radio-group class="checleft" formControlName="laboro" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="col-6 displayFlex">
        <p class="inputRadio">El Soporte de los Titulos son válidos</p>
       <mat-radio-group class="checleft" formControlName="soporte" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="col-6 displayFlex">
        <p class="inputRadio width">Figura en la lista de casos de investigación de Asuntos internos</p>
       <mat-radio-group class="checleft" formControlName="figura" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="col-6 displayFlex">
        <p class="inputRadio">Tiene Antecedentes (CICPC)</p>
       <mat-radio-group class="checleft" formControlName="antecedentes" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="col-12 separador"></div>

    <div class="col-6 ">
        <p class="inputRadio">Elegile:</p>
       <mat-radio-group class="checleft" formControlName="elegible" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="col-6 displayFlex">
        <p class="texto marginTop">Observaciones</p>
        <mat-form-field style="width: 100%;" appearance="outline" >
            <mat-label>Observaciones</mat-label>
            <textarea matInput placeholder="Observaciones" formControlName="observaciones" ></textarea>
        </mat-form-field>
    </div>


    ///////////////////////////////////////////// -->
  <div class="col-6 margBottom">
    <div class="opcionCheck">
      <p class="texto">Tiene Cuenta en el Banco</p>
      <mat-checkbox formControlName="tiene_cuenta"></mat-checkbox>
    </div>
  </div>
  <div class="col-6 margBottom">
    <div class="opcionCheck">
      <p class="texto">Son válidos los antecedentes laborales</p>
      <mat-checkbox formControlName="validos"></mat-checkbox>
    </div>
  </div>
  <div class="col-6 margBottom">
    <div class="opcionCheck">
      <p class="texto">
        Localidad de residencia es la misma o cercana a lugar de trabajo
      </p>
      <mat-checkbox formControlName="localidad"></mat-checkbox>
    </div>
  </div>
  <div class="col-6 margBottom">
    <div class="opcionCheck">
      <p class="texto">Son válidas las referencias laborales</p>
      <mat-checkbox formControlName="validas_referencias"></mat-checkbox>
    </div>
  </div>
  <div class="col-6 margBottom">
    <div class="opcionCheck">
      <p class="texto">Laboró en el Banco anteriormente</p>
      <mat-checkbox formControlName="laboro"></mat-checkbox>
    </div>
  </div>
  <div class="col-6 margBottom">
    <div class="opcionCheck">
      <p class="texto">El Soporte de los Titulos son válidos</p>
      <mat-checkbox formControlName="soporte"></mat-checkbox>
    </div>
  </div>
  <div class="col-6 margBottom">
    <div class="opcionCheck">
      <p class="texto">
        Figura en la lista de casos de investigación de Asuntos internos
      </p>
      <mat-checkbox formControlName="figura"></mat-checkbox>
    </div>
  </div>
  <div class="col-6 margBottom">
    <div class="opcionCheck">
      <p class="texto">Tiene Antecedentes (CICPC)</p>
      <mat-checkbox formControlName="antecedentes"></mat-checkbox>
    </div>
  </div>
  <div class="col-6 margBottom">
    <div class="opcionCheck">
      <p class="texto">Elegile</p>
      <mat-checkbox formControlName="elegible"></mat-checkbox>
    </div>
  </div>
  <div class="col-12">
    <p class="texto marginTop">Observaciones</p>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Observaciones</mat-label>
      <textarea
        matInput
        placeholder="Observaciones"
        formControlName="observaciones"
      ></textarea>
    </mat-form-field>
  </div>
</form>
